const firebaseConfig = {
    apiKey: "AIzaSyCqa59AqbNYutaRxGY8qVrj0kZOWUTqsCM",
    authDomain: "fitnesia.firebaseapp.com",
    projectId: "fitnesia",
    storageBucket: "fitnesia.appspot.com",
    messagingSenderId: "591826030857",
    appId: "1:591826030857:web:da813e6fd20d4048a783d8"
  };

export default firebaseConfig;  